module.exports = __webpack_public_path__ + "media/images/icons/carrier_fs_logo-a2cd41995bc580747eaf9bbb4fc54a76.jpg";